import {bindGigyaToggleContent, bindInfoSubscription, setCustomData} from '.'
import {BRAND_KEY} from '../../brand'
import {searchCustomerByEmail} from '../../custom-hooks/use-gigya-ssr'

//const CONTAINER_ID = 'js-dlg-gigya-newsletter-container'

export default class GigyaBasicFormController {
    static isTrue = (value) => value === true || value === 'true'

    static onAfterScreenLoad(event) {
        //GigyaController.onAfterScreenLoad(event)
        bindGigyaToggleContent(event.sourceContainerID, '#gigya-subscribe-with-email-form')
        bindInfoSubscription(event.sourceContainerID, '#gigya-subscribe-with-email-form')
        //const gigyaTextbox = document.getElementById('gigya-textbox-email')
        /* if (DLG.config.isLogged) {
            gigyaTextbox.disabled = true
        } */
    }

    static async onBeforeValidation({formData}, message) {
        const email = formData['profile.email']
        const data = await searchCustomerByEmail(email)
        const errors = [
            {
                'profile.email': message,
            },
        ]
        // console.debug(data)
        if (data.totalCount !== 0) {
            //notifyError(data.message)
            //setLabelErrorClass(CONTAINER_GUEST_ID, 'profile.email', false)
            return errors[0]
        }
    }

    static onBeforeSubmit = (event) => {
        const {sourceContainerID} = event

        const mandatoryConsent = document.getElementById(sourceContainerID)
        const customCheckbox = mandatoryConsent.querySelector('.gigya-input-checkbox.fd-checkbox')

        const consent = mandatoryConsent.dataset.consentMandatory
        /*
        Mantenere per eventuali configurazioni lato screenset
        */

        if (
            (GigyaBasicFormController.isTrue(consent) || consent === null) &&
            customCheckbox !== null &&
            !GigyaBasicFormController.isTrue(customCheckbox.checked)
        ) {
            return false
        }
        return true
    }

    static onSubmit = (event, origin = null) => {
        setCustomData(event, origin)
    }

    static marketing = (event, countryCode, selector = null) => {
        const {sourceContainerID} = event

        // get the consent field related to the country code
        const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]

        const mandatoryConsent = document.getElementById(sourceContainerID) || document
        const querySelectorCheckbox = selector || '.gigya-input-checkbox.fd-checkbox'
        const customCheckbox = mandatoryConsent.querySelector(querySelectorCheckbox)

        //if (!customCheckbox.checked) return {}

        const isCG = {
            isConsentGranted: !!customCheckbox.checked,
            entitlements: customCheckbox.checked ? [`${BRAND_KEY}${countryCode}`] : [],
        }

        return {[siteConsent]: isCG}
    }

    static onBeforeScreenLoad() {
        const newsletterBtn = document.getElementById('js-show-newsletter-popup')
        newsletterBtn.addEventListener('click', () => {
            let interval
            let intervalC = 0
            const intervalM = 30
            ;(() => {
                interval = setInterval(() => {
                    const form = document.getElementById('gigya-subscribe-with-email-form')
                    if (intervalC > intervalM) {
                        clearInterval(interval)
                    } else if (form !== null) {
                        clearInterval(interval)
                        const inputName = form.querySelectorAll('[name = "profile.firstName"]')
                        const inputSurname = form.querySelectorAll('[name = "profile.lastName"]')
                        inputName[0].setAttribute('maxlength', '40')
                        inputSurname[0].setAttribute('maxlength', '40')
                    }
                    intervalC += 1
                }, 1000)
            })()
        })
    }

    static onAfterSubmit = async (e, ssrGigyaMethods, selector) => {
        const {getLiteToken, getAccountInfo, setAccountInfo, resendDOIConfirmationEmail} =
            ssrGigyaMethods

        const response = await getLiteToken(e.profile.email)
        const completeProfile = await getAccountInfo(null, response.token)

        // get the locale
        const lang = window.gigya.thisScript.lang.originalLang
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]

        const parameters = {
            regToken: response.token,
            preferences: GigyaBasicFormController.marketing(e, countryCode, selector),
        }

        if (countryCode === 'DE') {
            if (
                completeProfile?.subscriptions?.newsDlDE?.email?.isSubscribed &&
                completeProfile?.subscriptions?.newsDlDE?.email?.doubleOptIn?.status !== 'Confirmed'
            ) {
                resendDOIConfirmationEmail({
                    email: e.profile.email,
                    lang: window.gigya.thisScript.lang.originalLang,
                    subscriptionId: 'newsDlDE',
                })

                setTimeout(() => {
                    window.DOI.EVE.emit('EVENTS.GIGYA.DOI.MODAL')
                }, 1000)
            } else if (!completeProfile?.subscriptions?.newsDlDE?.email?.isSubscribed) {
                parameters.subscriptions = {
                    newsDlDE: {
                        email: {
                            isSubscribed: true,
                        },
                    },
                }

                setTimeout(() => {
                    window.DOI.EVE.emit('EVENTS.GIGYA.DOI.MODAL')
                }, 1000)
            }
        }
        console.debug('set-account-info')
        setAccountInfo(parameters)
    }
}
